import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as en } from '../i18n/en.json';
import { default as de } from '../i18n/de.json';
import {
  eslLinkRoutes,
  eslLinkStorageRoutes,
  eslSearchRoutes,
} from './esl-link-storage.routes';
import { SOFTLINE_PERMISSION_ESL_STORAGE } from './esl-link-storage.shared';
import { SOFTLINE_PERMISSION_ESL } from '@softapps/handel/esl-link';

export function provideEslLinkStorageProviders(config?: { storageSelection: boolean }) {
  if (config?.storageSelection && config?.storageSelection === true) {
    return [
      provideSoftAppsModule(
        {
          name: 'esl-link-storage',
          title: '#ESL.STORAGE_APP_TITLE',
          icon: 'fa-regular fa-tags',
          route: '/esl-link-storage/selection',
          permission: SOFTLINE_PERMISSION_ESL_STORAGE,
        },
        withSoftAppsModuleTranslation({ de, en }),
        withSoftAppsModuleRoutes({
          app: eslLinkStorageRoutes,
        })
      ),
    ];
  } else {
    return [
      provideSoftAppsModule(
        {
          name: 'esl-link-new',
          title: '#ESL.APP_TITLE',
          icon: 'fa-regular fa-tags',
          route: '/esl-link/associate',
          permission: SOFTLINE_PERMISSION_ESL,
        },
        withSoftAppsModuleTranslation({ de, en }),
        withSoftAppsModuleRoutes({
          app: eslLinkRoutes,
        })
      ),
    ];
  }
}

export const provideEslSearchProviders = () => {
  return provideSoftAppsModule(
    {
      name: 'esl-search',
      title: 'ESL Suche',
      icon: 'fa-solid fa-magnifying-glass',
      route: '/esl-search/flash',
      permission: SOFTLINE_PERMISSION_ESL,
    },
    withSoftAppsModuleTranslation({ de, en }),
    withSoftAppsModuleRoutes({
      app: eslSearchRoutes,
    })
  );
};
